import auction from '../data/auction.gif'
import event from '../data/event.gif'
import znote from '../data/z-notes.gif'
import am2spotify from '../data/am2spotify.gif'
import bidex from '../data/bidex.gif'
import kaska from '../data/kaska.gif'
import paylink from '../data/paylink.gif'
import spotty from '../data/spotty.gif'

const projects = {
  "data": [
    {
      id: 1,
      title: "Kaska",
      description:
        "An AI workforce platform where users can hire specialized agents for one-time or scheduled tasks and pay per execution with USDC.",
      image: kaska,
      github: "https://github.com/sheriifMahadi/kaska",
      url: "https://kaaska.vercel.app/",
      alt: "kaska-app-img"
    },
    {
      id: 2,
      title: "Bidex",
      description:
        "A full-stack auction platform where users can create listings, place bids, and manage auctions through a responsive interface.",
      image: bidex,
      github: "https://github.com/sheriifMahadi/django-auction-app",
      url: "https://bidex.pythonanywhere.com/",
      alt: "bidex-img"
    },
      {
         id: 3,
         title: "spotty",
         description:
           "A Spotify dashboard and playlist manager for exploring listening stats, organizing tracks, and safely restoring playlist changes.",
         image: spotty,
         github: "https://github.com/sheriifMahadi/AM2Spotify",
         url: "https://spotty.pythonanywhere.com",
         alt: "spotty-img"
      },
      {
        id: 4,
        title: "Paylink",
        description:
          "Create USDC payment links or QR codes containing the payment amount, wallet address, and expiry time for quick settlement.",
        image: paylink,
        github: "https://github.com/sheriifMahadi/paylink-poweredbyarc",
        url: "https://paylinck.vercel.app/create",
        alt: "paylink-app-img"
      },
      {
        id: 5,
        title: "z-notes",
        description:
          "A secure note-taking app for organizing ideas with tags, pinning, powerful search, autosave, and archive and trash management.",
        image: znote,
        github: "https://github.com/sheriifMahadi/notes_project_frontend",
        url: "https://z-note.netlify.app/",
        alt: "z-notes-img"
     },
  ]
}

export default projects
